import { Link } from 'react-router-dom'
import { useI18n } from '../i18n/LocaleContext'
import { Logo } from '../ui/Logo'

export function NotFound() {
  const { t } = useI18n()
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-canvas p-6 text-center">
      <Logo />
      <div>
        <p className="font-display text-[56px] tracking-tightish text-gray-300">404</p>
        <p className="mt-1 text-[14px] text-gray-600">{t.common.notFound}</p>
      </div>
      <Link
        to="/"
        className="text-[14px] font-semibold text-brand-700 underline-offset-[3px] hover:underline"
      >
        {t.nav.home}
      </Link>
    </main>
  )
}
